<template>
  <el-dialog
    :visible.sync="batchAdd"
    width="500px"
    title="选择球员"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    custom-class="yioks_alert2"
  >
    <el-form ref="batchInfo" :model="batchInfo" label-width="130px">
      <vue-scroll ref="scroll" :ops="ops">
        <div style="margin-right: 30px">
          <el-form-item label="是否精英机构球员" class="yioks-switch-grey">
            <el-switch
              v-model="isStuExit"
              active-text="是"
              inactive-text="否"
              active-color="#4cd964"
              @change="changeSwitch"
            ></el-switch>
          </el-form-item>

          <template v-if="isStuExit">
            <template v-if="userRole === 'coach'">
              <el-form-item
                label="选择球队"
                prop="unitId"
                :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]"
              >
                <el-select
                  v-model.trim="batchInfo.unitId"
                  style="width: 100%"
                  no-data-text="暂时没有球队，请前往球队管理添加球队"
                  :placeholder="$t('teamPlaceholder')"
                  @change="changeUnitUUid"
                >
                  <el-option
                    v-for="(item, index) in selectsquadList"
                    :key="index"
                    :label="item.label"
                    :value="item.key"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
            <template v-else>
              <el-form-item
                label="管理协会"
                required
                prop="organUuid"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-select
                  v-model.trim="batchInfo.organUuid"
                  style="width: 100%"
                  placeholder="请选择管理协会"
                  @change="changeBathOrg"
                >
                  <el-option
                    v-for="(item, index) in batchOrganList"
                    :key="index"
                    :value="item.organUuid"
                    :label="item.organShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="单位"
                required
                prop="youthUuid"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-select
                  v-model.trim="batchInfo.youthUuid"
                  style="width: 100%"
                  placeholder="请选择管理协会后再选择单位"
                  @change="changeBathCenter"
                >
                  <el-option
                    v-for="item in batchCenterList"
                    :key="item.uuid"
                    :value="item.uuid"
                    :label="item.youthShortName"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="选择球队"
                required
                prop="squadUuid"
                :rules="[{ required: true, message: '必填项' }]"
              >
                <el-select
                  v-model.trim="batchInfo.squadUuid"
                  style="width: 100%"
                  placeholder="请选择球队"
                  no-data-text="暂时没有球队，请前往球队管理添加球队"
                  @change="changeTeam"
                >
                  <el-option
                    v-for="item in batchSquadList"
                    :key="item.uuid"
                    :value="item.uuid"
                    :label="item.shortName"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item
              label="选择球员"
              required
              prop="playerUuid"
              :rules="[{ required: true, message: '必填项' }]"
            >
              <el-select
                v-model.trim="batchInfo.playerUuid"
                style="width: 100%"
                placeholder="请选择球员"
                no-data-text="暂时没有球员，请前往球员管理添加球员"
                filterable
                @change="playerChange"
              >
                <el-option
                  v-for="(item, index) in playerList"
                  :key="index"
                  :value="item.uuid"
                  :label="item.uname"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="场上主要位置"
              prop="position"
              :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]"
            >
              <el-select v-model="batchInfo.position" style="width:100%" placeholder="请选择场上主要位置">
                <el-option
                  v-for="item in positionList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item
              label="球员姓名"
              prop="player_name"
              :rules="[{ required: true, message: '必填项', trigger: 'blur' }]"
            >
              <el-input v-model="batchInfo.player_name" placeholder="请输入球员姓名"></el-input>
            </el-form-item>
            <el-form-item
              label="证件号"
              prop="player_id_number"
              :rules="[{ required: true, message: '必填项', trigger: 'blur' }, {
                    required: true, validator: checkIdnumber, trigger: ['blur', 'change']
                  }]"
            >
              <el-input v-model="batchInfo.player_id_number" placeholder="请输入证件号"></el-input>
            </el-form-item>
            <el-form-item
              label="场上主要位置"
              prop="position"
              :rules="[
                      { required: true, message: '必填项', trigger: 'change' },
                    ]"
            >
              <el-select style="width: 100%" v-model="batchInfo.position"  placeholder="请选择场上主要位置">
                <el-option
                  v-for="item in positionList"
                  :key="item.uuid"
                  :label="item.name"
                  :value="item.name"
                ></el-option>
              </el-select>
            </el-form-item>
          </template>
        </div>
      </vue-scroll>
    </el-form>
    <div class="btn-wrapper" style="text-align: center;">
      <el-button type="primary" @click="toAddScout">添加优秀苗子信息</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import {ops} from "@/utils/scrollIndialog";
  import storage from "@/utils/storage";
  import player from "@/api/player";
  import squad from "@/api/squad";
  import formRules from '@/utils/formRules/rules';
  import scout from "@/api/scout";
  export default {
    name: "SortDialog",
    data() {
      return {
        userRole: storage.get("userInfo").userRole,
        ops,
        batchAdd: false, // 弹窗
        batchInfo: {
        organUuid: "", // 协会
        organShortName: "",
        youthUuid: "", // 机构
        youthShortName: "",
        squadUuid: "", // 球队
        playerUuid: "", // 球员
        unitId: "", // 联合信息
        player_name: "",
        player_id_number: "",
        position: "",
      }, // 弹窗表单
        isStuExit: true,
        selectsquadList: [],
        playerList: [],
        batchSquadList: [],
        batchCenterList: [],
        centerList: [],
        batchOrganList: [],
        positionList: [],
      }
    },
    created(){
      if (this.userRole !== "coach") {
        this.getOrganListAndCenterList();
      } else {
        this.getSquadList();
      }
      // 获取场上位置
      this.loadPositionInfo();
    },
    methods: {
      /* 球员变化 */
    playerChange(val) {
      //   console.log("球员", val);
    },
      getOrganListAndCenterList() {
      let data = this.uuid;
      let request;
      if (this.userRole === "organ") {
        request = squad.getOrgListByOrgan;
      } else if (this.userRole === "system" || this.userRole === "admin" || this.userRole === "expert") {
        request = squad.getOrgListBySystem;
        data = "";
      } else if (
        this.userRole === "youth" ||
        this.userRole === "trainCamp" ||
        this.userRole === "club"
      ) {
        request = squad.getOrgListByYouth;
      } else if (this.userRole === "leader" || this.userRole === "coach") {
        // request = squad.getOrgListByCoachOrLeader;
        // console.log('在created方法中，短路此方法')
      }
      request(data).then((res) => {
        this.batchOrganList = res;
        this.organList = res;
        if(this.organList.length === 1) {
          this.$set(
              this.batchInfo,
              "organUuid",
              this.batchOrganList[0].organUuid
            );
            this.$set(
              this.batchInfo,
              "organShortName",
              this.batchOrganList[0].organShortName
            );
            this.centerList =
              this.batchOrganList.find((item) => {
                return item.organUuid === this.batchInfo.organUuid;
              }).youthList || [];
            this.batchCenterList = this.centerList;
            if (this.centerList.length === 1) {
              // this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.$set(
                this.batchInfo,
                "youthUuid",
                this.batchCenterList[0].uuid
              );
              this.$set(
                this.batchInfo,
                "youthShortName",
                this.batchCenterList[0].youthShortName
              );
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.batchInfo.youthUuid;
                }).squadList || [];
              this.batchSquadList = this.squadList;
              if (this.squadList.length === 1) {
                this.$set(this.batchInfo, "squadUuid", this.squadList[0].uuid);
                this.changeTeam(this.squadList[0].uuid);
              }
            }
          }
      });
    },
      getSquadList() {
      const _ = require("lodash");
      squad
        .getSquadListCoachAll()
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const uni_selectYouthList = _.unionBy(res, "squadUuid");
          this.selectsquadList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName} - ${item.shortName}`,
            value: item.squadUuid,
            key: JSON.stringify({
              squadUuid: item.squadUuid,
              youthUuid: item.youthUuid,
              organUuid: item.organUuid,
              organShortName: item.organShortName,
              youthShortName: item.youthShortName,
              shortName: item.shortName,
            }),
          }));
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
      checkIdnumber: (rules, val, callback) => {
      console.log('formRules.idNumber(val)', formRules.idNumber(val))
      if(formRules.idNumber(val)) {
        callback()
      } else {
        callback('证件号错误')
      }
    },
    changeBathCenter(val) {
      this.batchInfo.squadUuid = "";
      this.batchSquadList = [];
      this.batchInfo.youthShortName = "";
      if (this.batchInfo.youthUuid) {
        var obj = this.centerList.find((item) => {
          return item.uuid === this.batchInfo.youthUuid;
        });
        this.batchInfo.youthShortName =obj?obj.youthShortName : "";
        this.batchSquadList =obj? obj.squadList :  [];
        // if (this.batchSquadList.length === 1) {
        //   this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
        // }
      }
    },

    /* 球队变化 */
    changeTeam(val) {
      if (val) {
        player
          .getSquadPlayer(val)
          .then((res) => {
            this.playerList = res.map((item) => ({
              uuid: item.uuid,
              uname: item.idName,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },

      changeBathOrg(val) {
      this.batchSquadList = [];
      this.batchCenterList = [];
      this.$set(this.batchInfo, "youthUuid", "");
      this.$set(this.batchInfo, "organShortName", "");
      this.$set(this.batchInfo, "youthShortName", "");
      this.$set(this.batchInfo, "squadUuid", "");
      if (this.batchInfo.organUuid) {
        var obj =this.batchOrganList.find((item) => {
          return item.organUuid === this.batchInfo.organUuid;
        })
        this.batchInfo.organShortName = obj?obj.organShortName:"";
        this.batchCenterList =obj?obj.youthList : [];

        if (this.batchCenterList.length === 1) {
          // this.$set(this.selectVal, 'youthUuid', this.centerList[0].uuid)
          this.$set(this.batchInfo, "youthUuid", this.batchCenterList[0].uuid);
          this.$set(
            this.batchInfo,
            "youthShortName",
            this.batchCenterList[0].youthShortName
          );
          this.batchSquadList =
            this.batchCenterList.find((item) => {
              return item.uuid === this.batchInfo.youthUuid;
            }).squadList || [];
          if (this.batchSquadList.length === 1) {
            this.$set(this.batchInfo, "squadUuid", this.batchSquadList[0].uuid);
          }
        }else{
          if (this.batchInfo.organUuid) {
            const { youthList } = this.organList.find((item) => {
              return item.organUuid === this.batchInfo.organUuid;
            });
            this.centerList = youthList || [];
            if (this.centerList.length === 1) {
              this.$set(this.selectVal, "youthUuid", this.centerList[0].uuid);
              this.squadList =
                this.centerList.find((item) => {
                  return item.uuid === this.batchInfo.youthUuid;
                }).squadList || [];
              if (this.squadList.length === 1) {
                this.$set(this.selectVal, "squadUuid", this.squadList[0].uuid);
              }
            }
          }
        }
      }
    },
      changeSwitch(){
        this.$refs['batchInfo'].clearValidate();
      },
      /* 获取position定位 */
    loadPositionInfo() {
      const params = {};
      player
        .allPositionList(params)
        .then((res) => {
          this.positionList = res.map((item) => ({
            uuid: item.uuid,
            name: item.playerPositionName,
          }));
        })
        .catch((err) => {
          console.error(res);
        });
    },
    changeUnitUUid(val) {
      if (val) {
        const {
          organShortName,
          organUuid,
          shortName,
          squadUuid,
          youthShortName,
          youthUuid,
        } = JSON.parse(val);
        if (!squadUuid) {
          throw new Error("squadUuid is error:", squadUuid);
          return;
        }
        player
          .getSquadPlayer(squadUuid)
          .then((res) => {
            this.playerList = res.map((item) => ({
              uuid: item.uuid,
              uname: item.idName,
            }));
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    toAddScout() {
       let queryData = {};
      this.batchInfo.player_id_number = this.batchInfo.player_id_number.trim().toUpperCase();
      this.batchInfo.player_name = this.batchInfo.player_name.trim();
      if(this.isStuExit) {
         let { organShortName, youthShortName, playerUuid, unitId, position, ...rest } =
            this.batchInfo;
          queryData = {
            playerUuid,
            position: position,
            ...rest,
            oneUuid:this.$route.query.dataUuid
          };
          if (unitId) {
            const { organUuid, squadUuid, youthUuid } = JSON.parse(unitId);
            queryData = Object.assign({}, queryData, {
              organUuid,
              squadUuid,
              youthUuid,
            });
          }
      } else {
         let { player_name, player_id_number, position } = this.batchInfo;
         queryData = {
           player_name, player_id_number, position,oneUuid:this.$route.query.dataUuid
         }
      }
      // console.log('queryData', queryData)
      // return
      this.$refs.batchInfo.validate((valid) => {
        if(valid) {
          if(this.isStuExit){
            this.$router.push({
              name: "ScoutAdd",
              query: queryData,
            });
          }else{
            scout
            .scoutPlayerDataVerify(this.batchInfo.player_id_number,this.batchInfo.player_name)
            .then((res) => {
              if (res.code) {
                this.$message.error(res.msg);
              } else {
                this.$router.push({
                  name: "ScoutAdd",
                  query: queryData,
                });
              }
            })
            .catch((err) => {
              console.error(err);
            });
          }
        } else {
//          this.$message.warning("请先选择球员");
        }
      })

    },
  },

  }
</script>
